<template>
  <div>
    <div id="projects-autocomplete">
      <input type="hidden" name="project_id" v-model="id" />
      <input
        type="text"
        v-model="name"
        @focus="focused = true"
        @blur="onBlur"
        @keydown.up="highlightUp"
        @keydown.down="highlightDown"
        @keydown.enter.prevent="select(selectedIdx)"
        @keydown="search"
        @keyup="search"
        class="form-control"
      />
      <div
        id="autocomplete-list"
        class="list-group"
        v-if="focused"
        ref="autocompleteList"
      >
        <a
          href="#"
          class="list-group-item list-group-item-action"
          :class="{ active: idx == selectedIdx }"
          v-for="(project, idx) in filteredProjects"
          :key="idx"
          @click="select(idx)"
          >{{ project.name }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["projects", "project_id"],
  data() {
    return {
      name: "",
      focused: false,
      project_list: [...this.projects],
      selectedIdx: 0,
      id: this.project_id,
    };
  },
  mounted() {
    this.name = this.initialProject();
  },
  computed: {
    filteredProjects() {
      if (this.name) {
        return this.project_list.filter((project) =>
          project.name.toLowerCase().includes(this.name.toLowerCase())
        );
      } else {
        return this.project_list;
      }
    },
  },
  methods: {
    initialProject() {
      if (this.id) {
        const selected_project = this.project_list.find((project) => {
          return project.id == this.id;
        });
        return selected_project ? selected_project.name : "";
      }
      return ""; // Return a default value if `this.id` is not set
    },
    onBlur(e) {
      if (
        !e.relatedTarget ||
        e.relatedTarget == null ||
        !e.relatedTarget.classList.contains("list-group-item")
      ) {
        console.log(e.relatedTarget);
        this.focused = false;
      }
    },
    search(e) {
      if (e.keyCode >= 37 && e.keyCode <= 40) {
        return false;
      }
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
      this.focused = true;
      if(this.name == ''){
        this.id = '';
      }
      //   this.project_list = this.projects.filter((project) => {
      //     return (
      //       project.name.toLowerCase().indexOf(this.name.toLowerCase()) !== -1
      //     );
      //   });
    },
    highlightUp() {
      this.selectedIdx--;
      if (this.selectedIdx < 0) {
        this.selectedIdx = this.filteredProjects.length - 1;
      }
      this.highlight();
    },
    highlightDown() {
      this.selectedIdx++;
      if (this.selectedIdx >= this.filteredProjects.length) {
        this.selectedIdx = 0;
      }
      this.highlight();
    },
    highlight() {
      //console.log(this.selectedIdx);
      this.project_list.forEach((project, idx) => {
        project.selected = idx === this.selectedIdx;
      });
      this.setScrollPosition();
    },
    select(idx) {
      //console.log(this.filteredProjects[idx]);
      this.id = this.filteredProjects[idx].id;
      this.name = this.filteredProjects[idx].name;
      this.focused = false;
    },
    setScrollPosition() {
      this.$nextTick(() => {
        const autocompleteList = this.$refs.autocompleteList;
        if (autocompleteList) {
          const selectedItem =
            autocompleteList.querySelectorAll(".list-group-item")[
              this.selectedIdx
            ];
          if (selectedItem) {
            // Scroll the selected item into view
            selectedItem.scrollIntoView({
              behavior: "smooth",
              block: "center", // This will center the selected item within the list
            });
          }
        }
      });
    },
  },
};
</script>

<style>
#projects-autocomplete {
  position: relative;
}
#autocomplete-list {
  position: absolute;
  z-index: 1000;
  background: #fff;
  width: 100%;
  max-height: 400px;
  overflow-y: auto;
}
</style>